import { render, staticRenderFns } from "./SelectVat.vue?vue&type=template&id=0d8a120d"
import script from "./SelectVat.vue?vue&type=script&lang=ts"
export * from "./SelectVat.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d8a120d')) {
      api.createRecord('0d8a120d', component.options)
    } else {
      api.reload('0d8a120d', component.options)
    }
    module.hot.accept("./SelectVat.vue?vue&type=template&id=0d8a120d", function () {
      api.rerender('0d8a120d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SelectVat.vue"
export default component.exports